
import AttachmentHelper from '@/helpers/attachment';
import Logging from '@/logging';
import { Attachment, isEmbeddedAttachment, isS3Attachment, isTemplateAttachment, isUriAttachment, S3_Attachment } from '@/schema/attachment';
import axios from 'axios';

export function getS3DownloadLink(participant, bucketName, fileName) {
	const payload = {
		participant: participant,
		bucketName: bucketName,
		fileName: fileName
	};

	if (process.env.VUE_APP_GET_SIGNED_URL_DOWNLOAD === undefined) {
		throw new Error('VUE_APP_GET_SIGNED_URL_DOWNLOAD is not defined');
	}

	return axios.post(process.env.VUE_APP_GET_SIGNED_URL_DOWNLOAD, payload, {
		headers: { Authorization: `Bearer ${localStorage.getItem('rslt_id_token')}` }
	});
}

export async function attachmentDownload(participant, attachment: Attachment) {
	if (isS3Attachment(attachment)) {
		const response = await getS3DownloadLink(participant, attachment.bucket, attachment.key);
		let _data = response;
		let downloadLink = document.createElement('a');
		let linkId = `attachmentLink${Math.floor(Math.random() * 1000000)}`;
		downloadLink.id = linkId;
		downloadLink.href = _data.data.signed_url;
		downloadLink.target = '_blank';
		// @ts-ignore
		document.getElementById('app').appendChild(downloadLink);
		// @ts-ignore
		document.getElementById(linkId).click();
	} else if (isUriAttachment(attachment)) {
		let uri = attachment.uri;
		if (attachment.uri.startsWith('s3')) {
			let splittedArray = attachment.uri.substring(5).split('/');
			let _data;

			let bucketName = `${splittedArray[0]}`;
			const fileName = `${splittedArray.slice(1).join('/')}`;
			const response = await getS3DownloadLink(participant, bucketName, fileName);
			_data = response;
			uri = _data.data.signed_url;
		}

		let downloadLink = document.createElement('a');
		let linkId = `attachmentLink${Math.floor(Math.random() * 1000000)}`;
		downloadLink.id = linkId;
		downloadLink.href = uri;
		downloadLink.target = '_blank';
		// @ts-ignore
		document.getElementById('app').appendChild(downloadLink);
		// @ts-ignore
		document.getElementById(linkId).click();
	} else if (isEmbeddedAttachment(attachment)) {
		AttachmentHelper.showDocument(attachment.content, attachment.content_type);
	} else if (isTemplateAttachment(attachment)) {
		// call template renderer, get base64 and prepare link

		const payload = {
			channel: null,
			tone_of_voice: attachment.template.tone_of_voice,
			locale: attachment.template.locale,
			template_id: attachment.template.template_id,
			participant: this.action.participant,
			template_query_variables: {
				participant: this.action.participant,
				action: this.action.reference
			}
		};

		axios
			.post(`https://${process.env.VUE_APP_API_ENDPOINT}/templating/frontend-render/v1`, payload, {
				headers: { Authorization: `Bearer ${localStorage.getItem('rslt_id_token')}` }
			})
			.then(result => {
				// Download attachment
				AttachmentHelper.showDocument(result.data.base64_source || result.data.base64, result.data.content_type || 'text/html');
			});
	} else {
		Logging.warn('Cannot infer attachment type.');
	}
}
